<label
  *ngIf="showCheckbox"
  ui-checkbox
  [class.ant-table-selection-select-all-custom]="showRowSelection"
  [ngModel]="checked"
  [uiDisabled]="disabled"
  [uiIndeterminate]="indeterminate"
  (ngModelChange)="onCheckedChange($event)"></label>
<div class="ant-table-selection-extra" *ngIf="showRowSelection">
  <span ui-dropdown class="ant-table-selection-down" uiPlacement="bottomLeft" [uiDropdownMenu]="selectionMenu">
    <ui-icon uiType="down"></ui-icon>
  </span>
  <ui-dropdown-menu #selectionMenu="uiDropdownMenu">
    <ul ui-menu class="ant-table-selection-menu">
      <li ui-menu-item *ngFor="let selection of listOfSelections" (click)="selection.onSelect()">
        {{ selection.text }}
      </li>
    </ul>
  </ui-dropdown-menu>
</div>
